import { useMemo } from 'react'
import { useTranslation, useTypedSelector } from '.'
import {
    Category,
    singleCategoryTransformer,
} from '../state/transformers/CategoryTransformer'

export interface PieChartEntry {
    slag: string
    value: number
    fill: string
    name: string
}

const PIE_COLORS = [
    '#2a65bd',
    '#ff8962',
    '#4ecdc4',
    '#ef5350',
    '#795548',
    '#a3248e',
    '#cddc39',
    '#2bbb89',
    '#ffc107',
    '#2196f3',
    '#8bc34a',
    '#ff5734',
    '#009688',
    '#e91e63',
]

export const usePieChartData = (
    categoryMap: { [name: string]: number } | undefined | null
): PieChartEntry[] => {
    const translation = useTranslation()
    const { categories } = useTypedSelector((state) => state.category)

    return useMemo(() => {
        if (!categoryMap) return []

        const totalCases = Object.values(categoryMap).reduce(
            (acc, val) => acc + val,
            0
        )
        if (totalCases === 0) return []

        return Object.entries(categoryMap)
            .map(([slug, count]) => ({
                slag: slug,
                value: (count * 100) / totalCases,
            }))
            .filter((entry) => entry.value > 1)
            .sort((a, b) => b.value - a.value)
            .map((entry, index) => {
                let translatedName = ''

                if (entry.slag === 'category-missing') {
                    translatedName =
                        translation.caseworkerOpenReport.uncategorized
                } else if (categories) {
                    const categoryItem = categories.find(
                        (category) => category.slug === entry.slag
                    ) as Category

                    translatedName = singleCategoryTransformer(
                        categoryItem,
                        translation
                    ).name
                }

                return {
                    ...entry,
                    fill: PIE_COLORS[index % PIE_COLORS.length],
                    name: translatedName,
                }
            })
    }, [categoryMap, categories, translation])
}
